import { Alert } from '../../TempComponents';

// Create wrapper components
interface ConfigLifeCycleInfoProps {
  children: React.ReactNode;
  name: string;
  details: string;
  showInfoCondition: boolean;
  visibilityCondition?: boolean;
}

const ExperimentalFeature = ({
  children,
  name,
  details,
  showInfoCondition,
  visibilityCondition = true,
}: ConfigLifeCycleInfoProps) => {
  return (
    <>
      {visibilityCondition && (
        <div className="space-y-2">
          {children}
          {showInfoCondition && (
            <Alert variant="info">
              <strong>{name} is experimental.</strong> {details}
            </Alert>
          )}
        </div>
      )}
    </>
  );
};

const DeprecatedFeature = ({
  children,
  name,
  details,
  showInfoCondition,
  visibilityCondition = true,
}: ConfigLifeCycleInfoProps) => {
  return (
    <>
      {visibilityCondition && (
        <div className="space-y-2">
          {children}
          {showInfoCondition && (
            <Alert variant="warning">
              <strong>{name} is deprecated</strong> {details}
            </Alert>
          )}
        </div>
      )}
    </>
  );
};

export { ExperimentalFeature, DeprecatedFeature };
